export default __webpack_public_path__ + "static/śpiworek-58f690348392c5dfe957c26190b60fcc.jpg";